import { inject, Injectable } from '@angular/core';
import {
  AccountClient,
  SearchAccountWithStatsRequest,
} from '../../../core/openapi/bff-user-portal';
import { map, Observable } from 'rxjs';
import { IUserAccounts } from './model/user-accounts.interface';
import { UserAccountsMapper } from './user-accounts.mapper';
import { IUserAccount } from './model/user-account.interface';

@Injectable({
  providedIn: 'root',
})
export class UserAccountsService {
  private readonly accountClient = inject(AccountClient);

  private pageSize = 20;

  public loadAccounts(
    pageNumber = 0,
    currentId: string | null,
  ): Observable<IUserAccounts> {
    const searchAccountWithStatsRequest: SearchAccountWithStatsRequest = {
      skip: pageNumber * this.pageSize,
      take: this.pageSize,
      includeTotalCount: true,
      priorityAccountId: currentId,
    };

    return this.accountClient
      .v1AccountSearchWithStatsPost(searchAccountWithStatsRequest)
      .pipe(
        map((response) => ({
          total: response.totalCount ?? 0,
          canLoadMore: response.items?.length === this.pageSize,
          items: response.items?.map(UserAccountsMapper.fromDto) ?? [],
        })),
      );
  }

  public loadSummary(): Observable<IUserAccount> {
    return this.accountClient
      .v1AccountAggregationStatsGet()
      .pipe(map(UserAccountsMapper.fromAggregatedDto));
  }
}
